<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li m20">
                <div class="form__ttl">회사명<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" v-model="userData.companyName" disabled>
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">사업자 등록번호<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="number" v-model="params.companyNumber">
                    </label>
                    <div class="hint on" v-show="$v.params.companyNumber.$error">{{ valid.msg.companyNumber }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">팩스번호</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="number" v-model="params.companyFax">
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">소재지</div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" v-model="userData.companyAddress1" disabled>
                    </label>
                  </div>
                  <div class="inline">
                    <label class="input">
                      <input type="text" v-model="userData.companyAddress2" disabled>
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">담당자(대표자) 이름<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactName">
                    </label>
                    <div class="hint on" v-show="$v.params.contactName.$error">{{ valid.msg.contactName }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">담당자(대표자) E-Mail<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactEmail">
                    </label>
                    <div class="hint on" v-show="$v.params.contactEmail.$error">{{ valid.msg.contactEmail }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">담당자(대표자) 연락처<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactPhone">
                    </label>
                    <div class="hint on" v-show="$v.params.contactPhone.$error">{{ valid.msg.contactPhone }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">담당자 부서</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactDepartment">
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li">
                <div class="form__ttl">담당자 직통번호</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" v-model="params.contactTel">
                    </label>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="btn_wrap">
            <button class="btm on" @click="fnSave">변경하기</button> <!--활성화: on-->
          </div>
        </div>
        <div class="line_10"></div>
        <div class="notice__page" style="height: 0;">
          <ul class="notice__page__ul">
            <!--            <li class="notice__page__li type_02" @click="$router.push('/comm/mypage/modifyPhone').catch(() => {})">-->
            <!--              <div class="txt">-->
            <!--                <p>휴대폰 번호 변경하기</p>-->
            <!--              </div>-->
            <!--              <i class="i_right"></i>-->
            <!--            </li>-->
            <li class="notice__page__li type_02" @click="$router.push('/mypage/modifyPWD').catch(() => {})">
              <div class="txt">
                <p>비밀번호 변경</p>
              </div>
              <i class="i_right"></i>
            </li>
            <li class="notice__page__li type_02" style="margin-bottom: 0;" @click="$router.push('/mypage/modifyAddress').catch(() => {})">
              <div class="txt">
                <p>소재지 변경</p>
              </div>
              <i class="i_right"></i>
            </li>
          </ul>
          <div class="secession underline" @click="fnWithdraw">회원 탈퇴</div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {required} from "vuelidate/lib/validators";

export default {
  data: function () {
    return {
      valid: {
        msg: {}
      },
      isShow: false,
      params: {
        companyNumber: this.$store.getters['account/getUserData'].companyNumber,
        companyFax: this.$store.getters['account/getUserData'].companyFax,
        contactName: this.$store.getters['account/getUserData'].contactName,
        contactEmail: this.$store.getters['account/getUserData'].contactEmail,
        contactPhone: this.$store.getters['account/getUserData'].contactPhone,
        contactDepartment: this.$store.getters['account/getUserData'].contactDepartment,
        contactTel: this.$store.getters['account/getUserData'].contactTel,
      }
    }
  },
  computed: {
    userData: function () {
      console.log(this.$store.getters['account/getUserData'])
      return this.$store.getters['account/getUserData']
    }
  },
  created: function () {
  },
  validations: {
    params: {
      companyNumber: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.companyNumber = '필수 항목 입니다.'
          }

          return true
        }
      },
      contactName: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactName = '필수 항목 입니다.'
            return false
          }
          return true
        }
      },
      contactPhone: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactPhone = '필수 항목 입니다.'
            return false
          }
          return true
        }
      },
      contactEmail: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.contactEmail = '필수 항목 입니다.'
            return false
          }
          return true
        }
      }
    }
  },
  methods: {
    fnSave: function () {
      if (!this.$Util.isValid(this.$v, this.$el)) return false

      const _this = this
      this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.CONFIRM, {title: '정보 수정', message: '변경하시겠습니까?'}, async function () {
        console.log(_this.params)
        const res = await this.$AccountSvc.modifyCompany(_this.params)
        const code = res.code
        const message = res.message
        const entity = res.entity

        console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
        if (code === 1) {
          setTimeout(function () {
            _this.$Util.modalAlert({message: '변경 되었습니다.'}, function () {
              setTimeout(function () {
                _this.$Util.refreshUserData()
              }, 200)
            })
          }, 200)
        } else {
          setTimeout(function () {
            _this.$Util.modalAlert({message: message})
          }, 200)
        }
      });
    },
    fnWithdraw: function () {
      this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.WITHDRAW, {}, async () => {
        const res = await this.$AccountSvc.withdraw()
        const code = res.code
        const message = res.message
        const entity = res.entity

        console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))
        const _this = this
        if (code === 1) {
          setTimeout(function () {
            _this.$router.replace({path: '/account/login'})
          }, 200)
        } else {
          setTimeout(function () {
            _this.$Util.modalAlert({message: message})
          }, 200)
        }
      })
    }
  }
}
</script>
<style scoped>
.required {
  color: red;
}
</style>
